import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-helena-article',
  templateUrl: './helena-article.component.html'
})
export class HelenaArticleComponent implements OnInit {
  articleId: string;

  constructor( private route:ActivatedRoute  ) { }
  title: string;
  sourcePath: string;
  ngOnInit(): void {
   this.articleId=this.route.snapshot.paramMap.get("articleId");
   console.log(this.articleId);
   this.sourcePath=`assets/articles/${this.articleId}.md`;

  }

}
